import { z } from "zod";
import { optionSchema } from "./common";
import { getObjectFromSchema } from "../utils/getObjectFromSchema";

export const touristSchema = z.object({
  tourist_firstName: z.string().default(""),
  tourist_lastName: z.string().default(""),
  tourist_lastNameLatin: z.string().default(""),
  tourist_firstNameLatin: z.string().default(""),
  tourist_citizenship: optionSchema,
  tourist_foreignPassportNumber: z.string().default(""),
  tourist_identCode: z.string().default(""),
  tourist_birthDate: z.string().default(""),
  tourist_street: z.string().default(""),
  tourist_streetType: optionSchema,
  tourist_houseNumber: z.string().default(""),
  tourist_flatNumber: z.string().default(""),
  tourist_city: optionSchema,
});

export const touristValidatingSchema = touristSchema.omit({ tourist_identCode: true, tourist_flatNumber: true }).extend({});

export const touristFieldSchema = touristSchema.extend({
  readOnly: z.boolean().default(false),
  showDeleteButton: z.boolean().default(true),
  showSameAddressCheckbox: z.boolean().default(false),
  isInsurerTourist: z.boolean().default(false),
  isSameAddress: z.boolean().default(false),
  isExpanded: z.boolean().default(false),
});

export const touristFieldDefaultObject = getObjectFromSchema(touristFieldSchema);
export const touristDefaultObject = getObjectFromSchema(touristSchema);

export type TouristFieldType = z.infer<typeof touristFieldSchema>;

export type ShortTouristFieldType = Pick<TouristFieldType, "tourist_firstName" | "tourist_lastName" | "tourist_foreignPassportNumber" | "tourist_identCode" | "tourist_birthDate" | "tourist_street" | "tourist_houseNumber">
export type TouristType = z.infer<typeof touristSchema>;
